import immutableUpdate from 'immutable-update'

const initialState = {}

const reducers = { 

  USER_SET_DATA: (state, action) => {
    
    return immutableUpdate(
      state,
      window.playmotiv.user
    )
  },

  HYDRATE_GAME_STATUS: (state, { payload }) => {

    const { gameId, status } = payload

    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: { 
            status,
            events: {}
          }
        }
      }
    )
  },

  USER_EVENT_DATA_LOADED: (state, action) => {
    
    const { gameId, eventId, data } = action.payload

    const awards = state.gameData[gameId].status.awards || []
    const mergedAwards = [
      ...awards.map(a => {
                  const eventAward = data.awards.find(ea => ea.awardId === a.awardId)
                  return eventAward || a
                }),
      ...data.awards.filter(ea => !awards.some(a => a.awardId === ea.awardId))
    ]

    const instances = state.gameData[gameId].status.instances || []
                      .map(i => i.instanceId === data.instance.instanceId ? data.instance : i)


    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: {
            events: {
              [eventId]: data
            },
            status: {
              awards: mergedAwards,
              instances: instances
            }
          }
        }
      }
    )
  },

  USER_EVENT_KPI_UPDATE: (state, action) => {

    const { gameId, eventId, data } = action.payload

    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: {
            events: {
              [eventId]: {
                kpis: data
              }
            }
          }
        }
      }
    )
  },

  RANKING_DATA_LOADED: (state, action) => {

    const { gameId, eventId, rankingId, data } = action.payload

    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: {
            events: {
              [eventId]: {
                rankings: {
                  [rankingId]: {
                    list: data
                  }
                }
              }
            }
          }
        }
      }
    )
  },
  
  GROUP_DATA_LOADED: (state, action) => {

    const { gameId, eventId, groupId, data } = action.payload

    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: {
            events: {
              [eventId]: {
                groups: {
                  [groupId]: data
                }
              }
            }
          }
        }
      }
    )
  },

  USER_AVATAR_HAS: (state, action) => {
    
    return immutableUpdate(
      state,
      {
        avatarchecked: true,
        hasavatar: action.payload
      }
    )
  },

  SETNEWAWARDS_READED: (state, action) => {

    const { gameId, awards } = action.payload
    if (!state.gameData) return state
    if (!state.gameData[gameId]) return state

    return immutableUpdate(
      state,
      {
        gameData: {
          [gameId]: {
            status: {
              awards: state.gameData[gameId].status.awards
                                .map(a => ({ ...a, isNew: awards.find(award => award.awardId === a.awardId) ? false : a.isNew }))
            }
          }
        }
      }
    )
  }
}

const user = (state = initialState, action) => reducers[action.type] ? 
  reducers[action.type](state, action)
  :
  { ...state }

export default user 